/**************************************************************************************************/
/*   File: /src/app/shared/components/confirm-dialog/confirm-dialog.component.ts                  */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Wednesday May 15th 2019                                                        */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed May 15 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    Input,
    OnChanges,
    SimpleChanges,
    ElementRef
} from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from '../../../stores/states/root';
import { Confirm } from '../../models/confirm';
import { NGXLogger } from 'ngx-logger';
import { ModalService } from '../../services/utils/modal.service';
import { MessageType } from '../../enums/message.type.enum';

/**
 * The confirm dialog component
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'nwpl-frnt-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

    /**
     * The data of confirm dialog
     */
    @Input() data: Confirm;
    /**
     * The current element ref
     */
    @Input() reference: ElementRef;
    /**
     * Expose message type
     */
    MessageType = MessageType;

    /**
     * The constructor of the object
     */
    constructor(private store: Store<RootState>, private logger: NGXLogger, private modalService: ModalService) { }

    /**
     * The cancel function 
     */
    cancel() {
        if (this.data && this.data.cancel !== undefined) {
            this.store.dispatch(this.data.cancel);
        }
        this.close();
    }

    /**
     * The close dialog ref
     */
    close() {
        if (this.reference) {
            this.modalService.hide(this.reference);
        }
    }

    /**
     * The action
     * @param {Event} $event the click event
     */
    action() {
        if (this.data && this.data.do !== undefined) {
            this.store.dispatch(this.data.do);
        }
        this.close();
    }

    /**
     * The key listener on esc
     */
    @HostListener('keydown.esc')
    onEsc() {
        this.close();
    }

}